import { path } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';

/**
 * Fetch all feature flags for current client
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 *
 * @returns {Promise} Unresolved Promise from the API.
 */
var get = function get($axios) {
  return $axios.get(urls.apiV3('/features')).then(path(['data', 'data']));
};
export default {
  get: withAxios(get)
};